// list of disallowed characters
const REGEX_DISALLOWED_EMAIL_CHARACTERS = '[^\\0"#%\'()+/;<>?@\\\\|\\s]'

export const REGEX_ISO_8601_DATETIME = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(\.\d+)?(([+-][0-5]\d:[0-5]\d)|Z)$/
export const REGEX_VALID_EMAIL_ADDRESS = new RegExp(['^', REGEX_DISALLOWED_EMAIL_CHARACTERS, '+(\\+', REGEX_DISALLOWED_EMAIL_CHARACTERS, '+)?@([A-Za-z0-9]+([-.]*[A-Za-z0-9]*)*)+$'].join(''), 'i')
export const REGEX_VALID_GUID = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/